import React, { useEffect, useState } from 'react';
import '.././css/surveyExpired.css';

const ThankYou = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        localStorage.removeItem("guestUserDetails")
        // Trigger animation after component mounts
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="expired-container">
            <div className={`expired-card ${isVisible ? 'visible' : ''}`}>
                <div className="expired-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="80" height="80" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9 12l2 2 4-4"></path>
                    </svg>

                </div>
                <h1 className="expired-title">Thank You!</h1>
                <p className="expired-message">
                    Thank you for submitting the survey. We appreciate your feedback!
                </p>
            </div>
        </div>
    );
};

export default ThankYou; 